import React from "react";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ element: Component, publicOnly = false }) => {
  const token = localStorage.getItem("access_token");

  if (publicOnly) {
    return token ? <Navigate to="/users" replace /> : <Component />;
  }

  return token ? <Component /> : <Navigate to="/access-denied" replace />;
};

export default ProtectedRoute;